module.exports = __webpack_public_path__ + "static/media/logo.a8492566.png";